<template>
  <v-app id="app">
    <snackbar-vue />
    <v-main>
      <navigation-drawer v-if="!$route.meta.hideNavbar" />
      <transition name="slide-fade" mode="out-in" appear>
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/NavigationDrawer.vue";

export default {
  name: "App",
  components: {
    NavigationDrawer,
  },
};
</script>
<style scoped>
.theme--dark.v-application {
  background-color: var(--v-background-base) !important;
}

.v-navigation-drawer {
  background-color: var(--v-secondary-base) !important;
}
</style>

<style>
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: #191c29 !important;
  color: #fff !important;
}

.leaflet-popup-close-button {
  color: #fff !important;
}

.leaflet-interactive:focus,
path.leaflet-interactive:focus,
.leaflet-container:focus,
.leaflet-container *:focus,
.leaflet-tile-pane img:focus,
.leaflet-tile-pane canvas:focus,
canvas:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
</style>
